import { Container } from '@mui/material';
import React from 'react'
import DesktopMenu from './component/DesktopMenu';
import MobileMenu from './component/MobileMenu';

const LockerMenu = (props) => {
    const menuList = [ // You can pass 4 perameters for menu title, link, target and customClass
        {
        title: "Token",
        link: "/token",
        },                 
        {
        title: "About",
        link: "/about",
        },
        {
        title: "Development Timeline",
        link: "/developmenttimeline",
        },
        {
        title: "Contact Support",
        link: "#",
        },
      
        {
        title: "Download",
        link: "/comingsoon",
        customClass: "customclassbutton",
        },
    ];
  return (
    <Container maxWidth="xll" sx={{padding:"0 !important"}}
    data-aos="fade-zoom-in"
    data-aos-easing="ease-in"
    data-aos-delay="300"
    data-aos-offset="0"
    data-aos-duration="500"
    >
        <DesktopMenu  color={props.color} logo={props.logo} menuList={menuList} />
        <MobileMenu logo={props.logo} menuList={menuList} />
    </Container>
  )
}

export default LockerMenu